export default [
  {
    title: 'Smart',
    text: 'Get cash in exchange for the future value of your home. No loans, no monthly payments, no kidding.',
    icon: 'lightbulb',
  },
  {
    title: 'Simple',
    text: 'Complete your application, review your investment, sign investment documents. It really is that easy.',
    icon: 'check',
  },
  {
    title: 'Fast',
    text:
      'From start to finish (re: cash in your pocket) the whole process takes less than three weeks. A 10-minute online application gets things rolling.',
    icon: 'clock',
  },
  {
    title: 'Flexible',
    text:
      'We invest in homes and people not just zip codes and credit scores. And by “home” we don’t just mean single family. We love condos, too.',
    icon: 'flexible',
  },
  {
    title: 'Transparent',
    text:
      'No surprises, no fine print, no hidden fees. Whether we’re in the evaluation phase or the signing, you’ll always know exactly what’s going on.',
    icon: 'speech',
  },
  {
    title: 'Neighborly',
    text:
      'You’ll have a dedicated Investment Manager to walk you through it all and even work with you to find solutions that work for your unique financial situation.',
    icon: 'person',
  },
];
